import { useFadeUp } from '../hooks/usefadeup'
import {
  FiUser, FiSearch, FiAward,
  FiCheckCircle, FiShield, FiBarChart2,
} from 'react-icons/fi'
import './Garantias.css'

const guarantees = [
  {
    title: 'Atendimento Personalizado',
    desc: 'Garantimos um acompanhamento exclusivo e consultivo, adaptado à realidade específica de cada parceiro.',
    icon: FiUser,
  },
  {
    title: 'Diagnóstico de Necessidades',
    desc: 'Efetuamos um levantamento minucioso dos seus requisitos para propor as coberturas e capitais ideais.',
    icon: FiSearch,
  },
  {
    title: 'Know-how Especializado',
    desc: 'Dispomos de uma equipa técnica altamente qualificada e com profundo conhecimento do setor de mediação e corretagem.',
    icon: FiAward,
  },
  {
    title: 'Soluções Sob Medida',
    desc: 'Selecionamos e negociamos as melhores apólices e condições do mercado junto das seguradoras líderes.',
    icon: FiCheckCircle,
  },
  {
    title: 'Gestão Rápida de Sinistros',
    desc: 'Asseguramos uma regularização ágil e sem burocracias, prestando assistência total nos momentos mais críticos.',
    icon: FiShield,
  },
  {
    title: 'Prevenção & Gestão de Risco',
    desc: 'Identificamos vulnerabilidades e recomendamos medidas de segurança ativas para mitigar riscos nas suas atividades.',
    icon: FiBarChart2,
  },
]

export default function Garantias() {
  const sectionRef = useFadeUp<HTMLElement>(800)

  return (
    <section id="garantias" className="gr" ref={sectionRef}>
      <div className="gr-inner">
        {/* Top: 60/40 Split */}
        <div className="gr-hero-split">
          {/* Left: 60% Corporate Image & Glass Floating Card */}
          <div className="gr-image-col" data-fade data-fade-delay="0">
            <img
              src="/garantias_hero.png"
              alt="Equipa Makhowo em Reunião Corporativa"
              className="gr-hero-img"
              loading="lazy"
            />
            <div className="gr-image-overlay"></div>
          </div>

          {/* Right: 40% Text Content */}
          <div className="gr-content-col">
            <div className="gr-header-wrapper" data-fade data-fade-delay="100">
              <h2 className="gr-title">Compromisso e Garantia</h2>
            </div>
            <div className="gr-body-wrapper">
              <p className="gr-description" data-fade data-fade-delay="150">
                A Makhowo assume a responsabilidade de gerir os seus riscos com profissionalismo e transparência. Guiados por princípios de integridade, oferecemos soluções desenhadas com rigor técnico para salvaguardar o seu património e assegurar a continuidade do seu negócio.
              </p>
              <div className="gr-focus-points" data-fade data-fade-delay="200">
                <div className="gr-focus-item">
                  <span className="gr-focus-icon">✓</span>
                  <span>Conformidade Regulatória</span>
                </div>
                <div className="gr-focus-item">
                  <span className="gr-focus-icon">✓</span>
                  <span>Segurança Jurídica e Financeira</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom: Glassmorphic Guarantees Grid */}
        <div className="gr-grid-section">
          <div className="gr-grid-header" data-fade data-fade-delay="250">
            <h3 className="gr-grid-subtitle">As Nossas Garantias</h3>
            <p className="gr-grid-desc">Soluções integradas focadas na estabilidade e crescimento do seu negócio.</p>
          </div>

          <ul className="gr-grid">
            {guarantees.map(({ title, desc, icon: Icon }, i) => (
              <li
                key={title}
                className="gr-item-card"
                data-fade
                data-fade-delay={`${300 + i * 80}`}
              >
                <div className="gr-item-icon-wrapper">
                  <Icon className="gr-card-icon" />
                </div>
                <div className="gr-item-content">
                  <h4 className="gr-item-title">{title}</h4>
                  <p className="gr-item-desc">{desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}